/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
export function Reset({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><g clipPath="url(#Reset_svg__a)"><path fill="currentColor" d="M6.012 1.919A6.368 6.368 0 0 0 3.206 3.76l1.573-.272a.61.61 0 0 1 .702.488.59.59 0 0 1-.48.692L2.15 5.16a.61.61 0 0 1-.702-.487l-.53-2.82a.59.59 0 0 1 .48-.692.61.61 0 0 1 .702.487l.24 1.279a7.568 7.568 0 0 1 3.3-2.15 7.584 7.584 0 0 1 6.122.62 7.563 7.563 0 0 1 2.739 2.664c.348.574.624 1.2.812 1.865a7.54 7.54 0 0 1 .247 1.286 7.562 7.562 0 0 1-.71 4.08 7.583 7.583 0 0 1-1.625 2.231l-.01.01a7.573 7.573 0 0 1-2.854 1.692 7.57 7.57 0 0 1-3.614.274 7.554 7.554 0 0 1-2.581-.935 7.563 7.563 0 0 1-1.976-1.66 7.562 7.562 0 0 1-1.373-2.418 7.561 7.561 0 0 1-.35-3.502.6.6 0 1 1 1.19.162 6.361 6.361 0 0 0 .649 3.777c.226.44.496.843.801 1.206a6.429 6.429 0 0 0 4.611 2.268 6.385 6.385 0 0 0 2.27-.313 6.367 6.367 0 0 0 3.78-3.31c.26-.542.437-1.1.537-1.663a6.411 6.411 0 0 0-1.343-5.153A6.427 6.427 0 0 0 8.28 1.607a6.385 6.385 0 0 0-2.268.312Z" /></g><defs><clipPath id="Reset_svg__a"><path fill="currentColor" d="M0 0h16v16H0z" /></clipPath></defs></svg>;
}
;